import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    website: "",
    services: "",
    message: "",
  });

  const navigate = useNavigate();


  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post("https://dropshopi.com/api/contact.php", formData);
    console.log("Success:", response.data);
    toast.success("Your message has been sent!", { autoClose: 2000 });

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      website: "",
      services: "",
      message: "",
    });

    // Wait a moment for the toast, then navigate
    setTimeout(() => {
      navigate("/thankyou");
    }, 2000);
  } catch (error) {
    console.error("Error submitting form:", error);
    toast.error("Something went wrong. Please try again.", { autoClose: 3000 });
  }
};

  return (
    <div className="container py-5 contact-form-wrapper">
      <form className="text-white rounded shadow contact-form" onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="firstName" className="form-label">First Name</label>
            <input type="text" id="firstName" value={formData.firstName} onChange={handleChange} className="form-control custom-input" placeholder="Peter" required />
          </div>
          <div className="col-md-6">
            <label htmlFor="lastName" className="form-label">Last Name</label>
            <input type="text" id="lastName" value={formData.lastName} onChange={handleChange} className="form-control custom-input" placeholder="Parker" required />
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input type="email" id="email" value={formData.email} onChange={handleChange} className="form-control custom-input" placeholder="peter@parker.com" required />
        </div>

        <div className="mb-3">
          <label htmlFor="website" className="form-label">Website</label>
          <input type="text" id="website" value={formData.website} onChange={handleChange} className="form-control custom-input" placeholder="www.parker.com" />
        </div>

        <div className="mb-3">
          <label htmlFor="services" className="form-label">What services are you interested in?</label>
          <input type="text" id="services" value={formData.services} onChange={handleChange} className="form-control custom-input" placeholder="Google Ads" />
        </div>

        <div className="mb-3">
          <label htmlFor="message" className="form-label">Tell us about your business and/or request?</label>
          <textarea id="message" value={formData.message} onChange={handleChange} rows="4" className="form-control custom-input" placeholder="What does your business sell or offer?"></textarea>
        </div>

        <div className="d-grid">
          <button type="submit" className="btn btn-purple">Submit Request</button>
        </div>
      </form>

      {/* Toast Container */}
      <ToastContainer position="top-right" />
    </div>
  );
};

export default ContactForm;
